import React, {useState} from 'react';
import {connect} from 'react-redux';
import ValidationInputsWithRadio from '../../Shared/ValidationInputsWithRadio/ValidationInputsWithRadio';
import { Col, Container, Row} from 'reactstrap';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import {isMobile} from 'react-device-detect';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../Config';
import Select from 'react-select';
import {Months, Years} from './data';
import HeadLineComponent from '../../Block/AbroadBusinessIndividualBlock/HeadlineComponent';
import {getCcrReport, setIsShowPopup, reportDWH, setCustomerDetailCcr} from '../PortalsBlock/portalSlice';
import ChangeHetPayPopUp from '../ClientInformationBlock/ChangeHetPayPopUp';
import PopUp from '../../Shared/Popup/PopUp';
import {useEffect} from 'react';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import BusinessCcrReportSuccessWithA from './BusinessCcrReportSuccessWithA';
import BusinessCcrReportSuccess from './BusinessCcrReportSuccess';
import BusinessCcrReportFail from './BusinessCcrReportFail';
import BusinessCcrReportFailedWithA from './BusinessCcrReportFailedWithA';
import {reportDWHBuilder} from './reportDWH';

export const BusinessCcrReportMain = (props) => {
  const [typedNumber, setTypedNumber] = useState({id: null, value: ''});
  const [phoneNumber, setPhoneNumber] = useState({id: null, value: ''});
  const [dates, setDates] = useState([]);
  const [mail, setMail] = useState({id: null, value: ''});
  const [isAllowed, setIsAllowed] = useState({
    description: 'initialState',
    isAllowed: false,
  });
  const [data, setData] = useState();
  const [counter, setCounter] = useState(1);
  const [oldHetPay, setOldHetPay] = useState({
    id: '',
    name: '',
  });
  const reportDWH = (mode, params) => {
    const report = reportDWHBuilder(mode, params, props);
    props.reportDWH(report);
  };

  useEffect(() => {
    props.setCustomerDetailCcr({
      banNumber: phoneNumber.value,
      customerMail: mail.value,
    });
  }, [phoneNumber.value, mail.value]);
  useEffect(() => {
    reportDWH('DISPLAY_SEARCH_PAGE');
    if (!oldHetPay.id) {
      getOldHetPayName();
    }
  }, []);
  const getOldHetPayName = () => {
    props.portalState?.hetPaysNumbers?.map((h) => {
      if (h.id === props.portalState.selectedHetPay)
        setOldHetPay({
          id: h.id,
          name: h.name,
        });
    });
  };

  const form = [
    {
      inputName: 'מספר באן',
      id: 1,
      formType: 'BAN',
      type: 'number',
      pattern: /^[0-9]*$/,
      maxLength: '',
      regexPattern: /^[0-9]*$/,
    },
    {
      inputName: 'מייל',
      id: 2,
      formType: 'MAIL',
      pattern: '',
      maxLength: '',
      regexPattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
    },
  ];

  const checkDates = () => {
    let valid;
    dates.forEach((date) => {
      if (!date.year || !date.month) {
        valid = false;
      } else valid = true;
    });
    return valid;
  };

  let isValidPhoneNumber = false;
  let isValidMail = false;
  const patternTest = () => {
    isValidPhoneNumber = new RegExp(form[0].regexPattern).test(phoneNumber.value);
    isValidMail = new RegExp(form[1].regexPattern).test(mail.value.toLowerCase());
    if (isValidPhoneNumber && isValidMail && checkDates()) {
      return true;
    } else {
      return false;
    }
  };

  const getCcrReport = async () => {
    let orgId;
    props.portalState?.privateCompanyList.map((company) => {
      if (company.idNumber === props.portalState?.selectedHetPay) {
        return (orgId = company.orgId);
      }
    });

    reportDWH('SEARCH_BUTTON_CLICK');
    const validDates = dates.filter((d) => {
      props.showAppLoader();
      if (d.year != null && d.month != null) {
        return d;
      }
    });
    const result = await props.getCcrReport({
      orgId: orgId,
      selectedNumber: phoneNumber.value,
      eMail: mail.value,
      dates: validDates,
    });

    if (result.payload.error) {
      props.hideAppLoader();
      return setIsAllowed(result.payload);
    }
    setIsAllowed({
      isAllowed: result.payload.isAllowed,
      description: result.payload.description,
      newOrgId: result.payload.newOrgIdNumber,
      newOrgName: result.payload.newOrgName,
    });
    if (
      result.payload.description === 'MemberOfDifferentOrg' ||
      result.payload.description === 'OrgIdNotFound' ||
      result.payload.isAllowed == true
    ) {
      props.setIsShowPopup(true);
      reportDWH('MEMBER_OF_DIFF_ORG');
      if (result.payload.errorOrSuccessDescription == 'Success') {
        reportDWH('SUCCESS');
      }
    } else if (result.payload.errorOrSuccessDescription === 'BanNotFound') {
      reportDWH('BAN_NOT_FOUND');
    } else if (result.payload.errorOrSuccessDescription == 'Success') {
      reportDWH('SUCCESS');
    } else {
      reportDWH('ERROR');
    }
    setData(result.payload);
    props.hideAppLoader();
  };

  const handleOnChange = (e, kind, i) => {
    var date = dates.slice();
    date[i] = {...date[i], [kind]: e.value};
    setDates(date);
  };

  const handleClick = (bool) => {
    if (bool) {
      if (dates[counter - 1]?.year != null && dates[counter - 1]?.month != null) {
        setCounter(counter + 1);
      }
    } else {
      if (dates[counter - 1]?.year != undefined || dates[counter - 1]?.month != undefined) {
        setDates(dates.filter((d) => dates[counter - 1] != d));
      }
      setCounter(counter - 1);
    }
  };

  const monthYearPicker = () => {
    return (
      <>
        <Container fluid className='d-flex  flex-column  '>
          <HeadLineComponent boldTitle={'אנא בחרו חודשים'} />
          {Array.from({length: counter}).map((_, i) => {
            return (
              <Row
                key={i}
                className={`mt-2 d-flex  justify-content-start ${!isMobile && 'mx-auto'} `}
                style={!isMobile ? {width: '30.5%'} : {margin: '0 !important'}}>
                <Col xs='1' className=' p-0 d-flex justify-content-center align-items-center'>
                  {i > 0 && (
                    <div className='btn' onClick={() => handleClick(false)}>
                      <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <circle cx='12' cy='12' r='10' fill='white' stroke='black' stroke-width='2' />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M15 11C15.5523 11 16 11.4477 16 12V12C16 12.5523 15.5523 13 15 13L9 13C8.44772 13 8 12.5523 8 12V12C8 11.4477 8.44772 11 9 11L15 11Z'
                          fill='var(--theme-primary, #810ea9)'
                        />
                      </svg>
                    </div>
                  )}
                </Col>

                <Col xs={5}>
                  <Select
                    placeholder='בחר חודש'
                    classNamePrefix='חודש'
                    isRtl={true}
                    id={i}
                    options={Months}
                    required
                    onChange={(e) => {
                      handleOnChange(e, 'month', i);
                    }}
                  />
                </Col>
                <Col xs={5}>
                  <Select
                    className='basic-single'
                    placeholder='בחר שנה'
                    isRtl={true}
                    id={i}
                    options={Years}
                    required
                    onChange={(e) => {
                      handleOnChange(e, 'year', i);
                    }}
                  />
                </Col>
                <Col xs='1' className='p-0 d-flex justify-content-center '>
                  {counter < 3 && i + 1 == counter && (
                    <div className='btn' onClick={() => handleClick(true)}>
                      <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <circle cx='12' cy='12' r='10' fill='white' stroke='black' stroke-width='2' />
                        <rect x='11' y='8' width='2' height='8' rx='1' fill='var(--theme-primary, #810ea9)' />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M15 11C15.5523 11 16 11.4477 16 12V12C16 12.5523 15.5523 13 15 13L9 13C8.44772 13 8 12.5523 8 12V12C8 11.4477 8.44772 11 9 11L15 11Z'
                          fill='var(--theme-primary, #810ea9)'
                        />
                      </svg>
                    </div>
                  )}
                </Col>
              </Row>
            );
          })}
        </Container>
      </>
    );
  };
  const getButtonModes = () => {
    if (isAllowed.description === 'initialState') {
      return (
        <>
          <Row className='justify-content-center mt-5'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center ${!patternTest() && 'disabled-btn'}`}>
              <BtnSubmit isBusiness text={`המשך`} onclick={() => getCcrReport()} />
            </Col>
          </Row>
          <Row className='justify-content-center mt-2'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center }`}>
              <BtnWhite isBusiness text={`חזרה לאיזור האישי`} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />
            </Col>
          </Row>
        </>
      );
    } else if ((isAllowed.isAllowed == false || isAllowed.error) && isAllowed.description !== 'MemberOfDifferentOrg') {
      return (
        <>
          <Row className='account-denied text-center  mt-2'>
            <Col xs='12' className='justify-content-center pr-0 pl-0'>
              <p className='font-14 newPurple-text mb-1'>{getCustomerValidationErrorDescription()}</p>
            </Col>
            <Col xs='12' className='justify-content-center pr-0 pl-0'>
              {isMobile ? (
                <a href={`tel:${window.Config.businessCallNumber}`} className='font-14 bold asBtn'>
                  אחרת חייג 234* לשיחה עם צוותון שירות
                </a>
              ) : (
                <p className='font-14 bold mb-0'>חיוג 234* לשיחה עם צוותון שירות</p>
              )}
            </Col>
          </Row>
          <Row className='justify-content-center mt-3'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center ${!patternTest() ? 'disabled-btn' : ''}`}>
              <BtnSubmit isBusiness text={`נסה שוב`} onclick={() => getCcrReport()} />
            </Col>
          </Row>
          <Row className='justify-content-center mt-2'>
            <Col xs='12' className={`btn-220 btn-row pr-0 pl-0 text-center }`}>
              <BtnWhite isBusiness text={`חזרה לאיזור האישי`} onclick={() => EpiContext.navigateTo(Config.businessLobbyUrl)} />
            </Col>
          </Row>
        </>
      );
    }
  };

  const radioButtonClick = (id, formType) => {
    setFormType({
      id: id,
      formType: formType,
    });
    if (typedNumber.value) {
      setTypedNumber((state) => {
        return {
          id: null,
          value: '',
        };
      });
    }
  };

  const getValue = (id) => {
    if (id === 1) return phoneNumber.value;
    else if (id === 2) return mail.value;
  };

  const onChange = (id, value) => {
    if (id === 1) {
      setPhoneNumber({
        id: id,
        value: value,
      });
    } else if (id === 2) {
      setMail({
        id: id,
        value: value,
      });
    }
  };
  const getCustomerValidationErrorDescription = () => {
    let error;
    if (isAllowed.description == 'PhoneNumberNotFound') {
      error = `לא נמצא מנוי, אנא בדקו את הפרטים שהוזנו`;
    } else if (isAllowed.description == 'AccountNotFound') {
      error = `מנוי זה לא משוייך לאחד מהארגונים שלך, אנא בדקו את הפרטים שהוזנו`;
    } else if (isAllowed.description == 'MemberOfDifferentOrg') {
      error = `מנוי זה משוייך לארגון אחר מרשימת הארגונים שלך, אנא בדקו את הפרטים שהוזנו`;
    } else if (isAllowed.description == 'ErrorOnValidation' || isAllowed.description == 'Unknown' || isAllowed.error) {
      error = `קרתה תקלה במהלך הזיהוי, אנא בדקו את הפרטים שהוזנו`;
    }
    return error;
  };
  const onButtonClick = () => {
    props.setIsShowPopup(false);
    props.hideAppLoader();
    setIsAllowed({
      ...isAllowed,
      isAllowed: true,
    });
    props.setIsShowPopup(true);
  };
  const onPopupClosing = () => {
    props.setIsShowPopup(false);
    setIsAllowed({
      description: 'initialState',
    });
    return props.isShowPopup;
  };

  return (
    <div className='business-ccr-report-main'>
      <ValidationInputsWithRadio
        form={form}
        formType={''}
        setTypedNumber={setTypedNumber}
        typedNumber={typedNumber}
        radioButtonClick={radioButtonClick}
        getButtonModes={getButtonModes}
        title={props.iContent.title.value}
        boldTitle={props.iContent.boldTitle.value}
        isRadio={false}
        onChange={onChange}
        getValue={getValue}
        isDateTime={true}
        dateTime={monthYearPicker}
      />
      {!isAllowed?.isAllowed ? (
        <PopUp showPopUp={props.portalState.isShowPopup} onClose={() => onPopupClosing()}>
          <ChangeHetPayPopUp
            isAllowed={isAllowed}
            setIsAllowed={setIsAllowed}
            oldHetPay={oldHetPay}
            setIsShowPopup={props.setIsShowPopup}
            btnText={'המשך'}
            onButtonClick={onButtonClick}
          />
        </PopUp>
      ) : (
        <PopUp preventWrapperClose={false} showPopUp={props.portalState.isShowPopup} onClose={() => onPopupClosing()}>
          {data?.isSuccess ? (
            data?.errorOrSuccessDescription === 'Success' ? (
              <BusinessCcrReportSuccess setIsShowPopup={props.setIsShowPopup} mail={mail.value} />
            ) : (
              <BusinessCcrReportSuccessWithA setIsShowPopup={props.setIsShowPopup} mail={mail.value} dates={dates} />
            )
          ) : data?.errorOrSuccessDescription === 'FailedWithA' ? (
            <BusinessCcrReportFailedWithA setIsShowPopup={props.setIsShowPopup} mail={mail.value} dates={dates} />
          ) : (
            <BusinessCcrReportFail />
          )}
        </PopUp>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  portalState: state.portalsBlock,
});

const mapDispatchToProps = {
  getCcrReport,
  hideAppLoader,
  showAppLoader,
  setIsShowPopup,
  reportDWH,
  setCustomerDetailCcr,
};

export default connect(mapStateToProps, mapDispatchToProps)(BusinessCcrReportMain);
